<template>
  <div class="game-container">
    <div class="game-card">
      <!-- 搜索和筛选区域 -->
      <div class="filter-section">
        <!-- 搜索和收费类型 -->
        <div class="filter-row">
          <span class="filter-label">游戏下载：</span>
          <el-radio-group
            v-model="searchForm.download_type"
            size="small"
            @change="handleSearch"
          >
            <el-radio-button label="">全部</el-radio-button>
            <!-- <el-radio-button label="free">免费下载</el-radio-button> -->
            <el-radio-button label="vip">VIP</el-radio-button>
          </el-radio-group>
        </div>

        <!-- 游戏类型 -->
        <div class="filter-row">
          <span class="filter-label">游戏类型：</span>
          <el-radio-group
            v-model="searchForm.category"
            size="small"
            @change="handleSearch"
          >
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="quest">Quest</el-radio-button>
            <!-- <el-radio-button label="tutorial">教程</el-radio-button> -->
            <el-radio-button label="steamvr">SteamVR</el-radio-button>
            <!-- <el-radio-button label="other">其他</el-radio-button> -->
          </el-radio-group>
        </div>

        <!-- 搜索框 -->
        <div class="search-input">
          <el-input
            v-model="searchText"
            placeholder="请输入游戏名称"
            prefix-icon="el-icon-search"
            clearable
            @keyup.enter.native="handleSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"
              >搜索</el-button
            >
          </el-input>
        </div>
      </div>

      <!-- 游戏卡片列表 -->
      <div class="game-grid">
        <div
          v-for="item in games"
          :key="item.id"
          class="game-item"
          @click="handleCardClick(item.id)"
        >
          <el-card shadow="hover" class="game-card-inner">
            <div class="image-wrapper">
              <el-image :src="item.cover" fit="cover" class="game-image" />
              <div class="tags-container">
                <el-tag
                  :type="item.download_type !== 'vip' ? 'success' : 'danger'"
                  class="price-tag"
                >
                  {{ item.download_type !== "vip" ? "免费" : "VIP" }}
                </el-tag>
                <el-tag :type="getCategoryType(item.category)" class="category-tag">
                  {{
                    item.category === "quest"
                      ? "Quest"
                      : item.category === "tutorial"
                      ? "教程"
                      : item.category === "steamvr"
                      ? "SteamVR"
                      : item.category === "other"
                      ? "其他"
                      : ""
                  }}
                </el-tag>
                <el-tag
                  v-if="isPublishedToday(item.game_update_time)"
                  type="success"
                  class="category-tag"
                >
                  新发布
                </el-tag>
              </div>
            </div>
            <div class="game-info">
              <h3 class="game-title">{{ item.title }}</h3>
              <p class="release-date">{{ getTheTime(item.game_update_time) }}</p>
            </div>
          </el-card>
        </div>
      </div>

      <!-- 分页组件 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import { getMqList } from "@/api";
import { formatTimeAgo } from "@/utils";
export default {
  name: "Home",
  data() {
    return {
      searchText: "",
      searchForm: {
        type: "",
        download_type: "",
        category: "",
      },
      currentPage: 1,
      pageSize: 12,
      games: [],
      total: 0,
    };
  },

  mounted() {
    this.fetchGames();
  },

  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchGames();
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 使用平滑滚动效果
      });
    },

    handleSearch() {
      this.currentPage = 1;
      this.fetchGames();
    },

    fetchGames() {
      getMqList({
        page: this.currentPage,
        pageSize: this.pageSize,
        title: this.searchText,
        download_type: this.searchForm.download_type,
        category: this.searchForm.category,
        type: this.searchForm.type,
      })
        .then((res) => {
          this.games = res.data.data;
          this.total = res.data.pagination.total;
        })
        .catch((err) => {
          console.error("获取游戏列表失败:", err);
          this.$message.error("获取游戏列表失败");
        });
    },

    handleCardClick(id) {
  // 构建游戏详情页面的URL
  const routeData = this.$router.resolve({ name: "GameMoQuDetail", params: { id } });
  // 在新窗口中打开
  window.open(routeData.href, '_blank');
},
    getCategoryType(category) {
      switch (category) {
        case "quest":
          return "primary";
        case "tutorial":
          return "success";
        case "steamvr":
          return "warning";
        case "other":
          return "info";
        default:
          return "info";
      }
    },
    getTheTime(time) {
      return formatTimeAgo(time);
    },
    isPublishedToday(dateString) {
      const publishDate = new Date(dateString);
      const today = new Date();

      return (
        publishDate.getFullYear() === today.getFullYear() &&
        publishDate.getMonth() === today.getMonth() &&
        publishDate.getDate() === today.getDate()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.game-container {
  padding: 20px;
  min-height: 100vh;
  background: #f5f7fa;

  @media screen and (max-width: 768px) {
    padding: 12px;
  }
}

.game-card {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  max-width: 1400px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    padding: 16px;
  }
}

.filter-section {
  margin-bottom: 24px;

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
  }

  .filter-row {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    @media screen and (max-width: 768px) {
      margin-bottom: 12px;
      gap: 8px;
      flex-direction: column;
      align-items: flex-start;

      .filter-label {
        margin-bottom: 4px;
      }

      .el-radio-group {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-right: 0;
        gap: 8px;

        :deep(.el-radio-button) {
          flex: 1;
          min-width: calc(33.33% - 6px);

          .el-radio-button__inner {
            width: 100%;
            padding: 8px;
            text-align: center;
            border: 1px solid #dcdfe6;
            margin: 0;
            border-radius: 4px;
            height: 32px;
            line-height: 1;
            box-sizing: border-box;
          }

          &:first-child .el-radio-button__inner {
            border-left: 1px solid #dcdfe6;
          }

          &.is-active .el-radio-button__inner {
            border-color: #409eff;
            color: #fff;
            background-color: #409eff;
            z-index: 1;
          }
        }
      }
    }

    .filter-label {
      color: #606266;
      font-size: 14px;
      white-space: nowrap;
    }

    .el-radio-group {
      margin-right: 16px;
    }
  }
}

.search-input {
  max-width: 400px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;

    :deep(.el-input__inner) {
      height: 40px;
      line-height: 40px;
    }

    :deep(.el-input-group__append) {
      padding: 0 12px;
      height: 40px;
      line-height: 40px;
    }
  }

  .el-input-group__append {
    background-color: #409eff;
    border-color: #409eff;
    color: white;
    padding: 0 16px;

    &:hover {
      background-color: #66b1ff;
    }
  }
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 24px;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
  }
}

.game-item {
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-4px);
  }
}

.game-card-inner {
  height: 100%;
  border: none;
  overflow: hidden;

  :deep(.el-card__body) {
    padding: 0;
  }
}

.image-wrapper {
  position: relative;
  padding-top: 75%;
  overflow: hidden;

  .game-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .tags-container {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    z-index: 1;
    gap: 4px;
    .price-tag,
    .category-tag {
      padding: 0 8px;
      height: 24px;
      line-height: 24px;
      border-radius: 4px;
      font-size: 12px;
    }
  }
}

.game-info {
  padding: 12px;

  .game-title {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    min-height: 40px;

    @media screen and (max-width: 768px) {
      font-size: 13px;
      min-height: 36px;
    }
  }

  .release-date {
    margin: 0;
    font-size: 12px;
    color: #909399;

    @media screen and (max-width: 768px) {
      font-size: 11px;
    }
  }
}

// 非移动端下的按钮样式
@media screen and (min-width: 769px) {
  :deep(.el-radio-button__inner) {
    padding: 8px 16px;
    font-size: 13px;
    border: 1px solid #dcdfe6;
    margin-left: -1px;
    height: 32px;
    line-height: 1;
  }

  :deep(.el-radio-button:first-child .el-radio-button__inner) {
    border-radius: 4px 0 0 4px;
    margin-left: 0;
  }

  :deep(.el-radio-button:last-child .el-radio-button__inner) {
    border-radius: 0 4px 4px 0;
  }

  :deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
    border-color: #409eff;
    z-index: 1;
  }
}

.pagination {
  text-align: center;
  margin-top: 32px;

  @media screen and (max-width: 768px) {
    margin-top: 24px;
  }
}


</style>
